import CoreBase from '../../services/engines/CoreBase';
import gatewayService from '../../services/GatewayService';
import responseHelper from '../../services/ResponseHelper';
import umlNotesCache from './UmlNotesCache';

const _name = 'UmlSchemaListFetcher';
const TOPIC = 'Jerny.UmlWorkspace'; // default topic voor de Load Uml-lijst — zie AANNAME hieronder
const PAGE_SIZE = 50;

// AANNAME (nog te verifiëren): "service" is in de UmlSchemaDlg een vrij invulbaar veld,
// maar CsCodeGenConfigFetcher laat zien dat topic-routing in de echte app impliciet via
// `type` lijkt te lopen (geen expliciet topic-argument in de save-call zelf, enkel bij het
// OPHALEN van een lijst). Load Uml doorzoekt daarom altijd de vaste TOPIC hierboven, ongeacht
// wat de user in het service-veld typt — dat veld wordt wel opgeslagen in de note-data zelf,
// maar bepaalt (nog) niet waar de note staat. Moet bevestigd worden tegen de echte BE.
class UmlNoteFetcher extends CoreBase {
    fetch = async () => {
        try {
            const umlType = 'UmlSchema';

            const resp = await gatewayService.getUserEntries(TOPIC, 1, PAGE_SIZE, umlType);
            if (responseHelper.check(resp, '', `${_name}.fetch`) < 0) {
                this.logError('fetch', `code: ${resp?.status}`);
                return [];
            }

            let items = resp.data.items ?? [];
            items = items.filter((x) => x.stateId !== 999 && x.type === umlType);

            umlNotesCache.setCache(items);
            return items;
        } catch (error) {
            this.logError('fetch', error.message);
            return [];
        }
    };
}

const umlNoteFetcher = new UmlNoteFetcher();
export default umlNoteFetcher;
